/* Definitions of actions coming from the clients-fe */
import { CLIENT_SEND_MESSAGE, CLIENT_TYPING } from '../constants/request-types';

export const INIT_WEBSOCKET = 'from-client-frontend/init-websocket';
export const INIT_WEBSOCKET_UNAUTHORIZED = 'from-client-frontend/init-websocket-unauthorized';
export const REQUEST_VISITOR_TOKEN = 'from-client-frontend/request-visitor-token';
export const REALTIME_CLIENT_INITIALIZED = 'from-client-frontend/initialized';
export const STORE_SESSION_INFO = 'from-client-frontend/store-session-info';
export const REQUEST_START_CHAT_TECHNICAL = 'from-client-frontend/request-start-chat-technical';
export const REQUEST_LOGIN_PRESALE = 'from-client-frontend/request-login-presale';
export const REQUEST_START_CHAT_CANCELLATION = 'from-client-frontend/request-start-chat-cancellation';
export const STORE_VISITOR_TOKEN = 'from-client-frontend/store-visitor-token';
export const SET_PROMO_PARAMS = 'from-client-frontend/store-promo-params';

export const SEND_CHAT_MESSAGE_PENDING = 'from-client-frontend/send-chat-message-pending';
export const SEND_CHAT_MESSAGE = 'from-client-frontend/send-chat-message';
export const SEND_CHAT_MESSAGE_SUCCEEDED = 'from-client-frontend/send-chat-message-succeeded';
export const SEND_CHAT_MESSAGE_FAILED = 'from-client-frontend/send-chat-message-failed';
export const SEND_CHAT_INQUIRY = 'from-client-frontend/send-chat-inquiry';

export const CLIENT_IS_TYPING = 'from-client-frontend/client-is-typing';
export const CHAT_CLOSED_BY_CLIENT = 'from-client-frontend/chat-closed-by-client';
export const SEND_OPERATOR_FEEDBACK = 'from-client-frontend/send-operator-feedback';
export const SEND_CHAT_FEEDBACK = 'from-client-frontend/send-chat-feedback';
export const CHAT_FEEDBACK_SUCCESS = 'from-client-frontend/chat-feedback-success';
export const SEND_CHAT_TRANSCRIPT = 'from-client-frontend/send-chat-transcript';
export const CHAT_WINDOW_RENDERED = 'from-client-frontend/chat-window-rendered';
export const SEND_USER_TO_THIRD_PARTY_FOR_REVIEW = 'from-client-frontend/send-user-to-third-party-for-review';
export const DISABLE_CLIENT_MESSAGING = 'from-client-frontend/disable-client-messaging';
export const SET_CHAT_STATUS = 'from-client-frontend/set-chat-status';
export const SET_CHAT_MINIMIZED = 'from-client-frontend/set-chat-minimized';
export const SET_CHAT_SHAKING = 'from-client-frontend/set-chat-shaking';
export const SET_CHAT_WINDOW_CLOSABLE = 'from-client-frontend/set-chat-closable';
export const SET_CHAT_OPENED_FROM = 'from-client-frontend/set-chat-opened-from';
export const SUBMIT_FILES_FOR_UPLOAD = 'from-client-frontend/submit-file-for-upload';
export const FAILED_TO_LOAD_VISITOR_TOKEN = 'from-client-frontend/failed-to-load-visitor-token';
export const CLOSE_CHAT_UI_WINDOW = 'from-client-frontend/close-chat-ui-window';

export const TRYING_TO_ESTABLISH_WEBSOCKET_CONNECTION = 'from-client-frontend/trying-to-establish-websocket-connection';
export const WEBSOCKET_CONNECTION_ESTABLISHED = 'from-client-frontend/websocket-connection-established';

export const SUBSEQUENT_SOCKET_CONNECT_RETRIES = 'from-client-frontend/subsequent-socket-connect-retries';
export const EXCEEDED_SOCKET_CONNECT_RETRIES = 'from-client-frontend/exceeded-socket-connect-retries';
export const SUBSEQUENT_FETCH_CONNECTIONS_RETRIES = 'from-client-frontend/subsequent-fetch-connections-retries';

export const PREFILL_USER_DATA = 'from-client-frontend/prefill-user-data';

export const USER_UNSEEN_CHAT_MESSAGES = 'from-client-frontend/user-unseen-chat-messages';
export const USER_RESET_UNSEEN_CHAT_MESSAGES = 'from-clients-frontend/user-reset-unseen-chat-messages';

export const SET_AI_ASSISTANT_THREAD_ID = 'from-clients-frontend/set-ai-assistant-thread-id';

export const initWebsocket = (payload) => {
  const { IMPULSE_URLS, CHAT_API, clientToken, username, reconnect = false, firstName, lastName, language } = payload;
  return {
    type: INIT_WEBSOCKET,
    payload: {
      IMPULSE_URLS,
      CHAT_API,
      clientToken,
      username,
      reconnect,
      firstName,
      lastName,
      language
    }
  };
};

export const initWebsocketUnAuthorized = () => ({
  type: INIT_WEBSOCKET_UNAUTHORIZED
});

export const requestVisitorToken = () => ({
  type: REQUEST_VISITOR_TOKEN
});

/**
 * @param {PrefillUserDataPayload} payload
 * @returns {{payload: PrefillUserDataPayload, type: string}}
 */
export const prefillUserData = ({ userNames = '', email = '' }) => ({
  type: PREFILL_USER_DATA,
  payload: {
    userNames,
    email
  }
});

/**
 * @param {StoreSessionInfoPayload} payload
 * @returns {{payload: StoreSessionInfoPayload, type: string}}
 */
export const storeSessionInfo = ({ IMPULSE_URLS = [], ...rest }) => {
  return {
    type: STORE_SESSION_INFO,
    payload: {
      IMPULSE_URLS,
      ...rest
    }
  };
};

/** @param {RequestLoginPresalePayload} payload */
export const requestLoginPresale = ({
  name,
  email,
  question,
  language,
  referring_url,
  serviceCompanyId,
  onComplete,
  onFailure
}) => ({
  type: REQUEST_LOGIN_PRESALE,
  payload: {
    name,
    email,
    question,
    language,
    referring_url,
    serviceCompanyId
  },
  onComplete,
  onFailure
});

/** @param {SetPromoParamsPayload} payload */
export const setPromoParams = ({ currency = null, promo = null, serviceCompanyId = null }) => ({
  type: SET_PROMO_PARAMS,
  payload: {
    currency,
    promo,
    serviceCompanyId
  }
});

export const requestStartChatTechincal = (launchParameters) => ({
  type: REQUEST_START_CHAT_TECHNICAL,
  payload: {
    ...launchParameters
  }
});

export const requestStartChatCancellation = ({ client, cancellation, cur_code, local_phone, request_id }) => ({
  type: REQUEST_START_CHAT_CANCELLATION,
  payload: {
    client,
    cancellation,
    cur_code,
    local_phone,
    request_id
  }
});

export const chatWindowRendered = () => ({
  type: CHAT_WINDOW_RENDERED
});

/**
 * @param {{visitorToken: string}} payload
 * @returns {{payload: {visitorToken: string}, type: string}}
 */
export const storeVisitorToken = ({ visitorToken }) => ({
  type: STORE_VISITOR_TOKEN,
  payload: {
    visitorToken
  }
});

/**
 * @param {{message: string}} payload
 * @returns {{payload: {message: string}, type: string, requestTypeName: string}}
 */
export const sendChatMessage = (payload) => ({
  type: SEND_CHAT_MESSAGE,
  requestTypeName: CLIENT_SEND_MESSAGE,
  payload
});

/** @returns {{requestTypeName: string, type: string}}*/
export const clientIsTyping = () => ({
  type: CLIENT_IS_TYPING,
  requestTypeName: CLIENT_TYPING
});

/**
 * @param {{ onFailure: function }} payload
 * @returns {{ type: string, onFailure: function }}
 */
export const chatClosedByClient = ({ onFailure }) => ({
  type: CHAT_CLOSED_BY_CLIENT,
  onFailure
});

/**
 * @param {{review:string, agree_publish: number, onComplete: function, onFailure: function}} payload
 * @returns {{payload: {agree_publish: number, review: string}, type: string, onComplete: function, onFailure: function}}
 */
export const sendFeedback = ({ review, agree_publish, onComplete, onFailure }) => ({
  type: SEND_OPERATOR_FEEDBACK,
  payload: {
    review,
    agree_publish
  },
  onComplete,
  onFailure
});

/**
 * @param {{visitor_comments:string, visitor_rating: number, onComplete: function}} payload
 * @returns {{payload: {visitor_comments:string, visitor_rating: number}, type: string, onComplete: function}}
 */
export const sendChatFeedback = ({ visitor_comments, visitor_rating, onComplete }) => ({
  type: SEND_CHAT_FEEDBACK,
  payload: {
    visitor_comments,
    visitor_rating
  },
  onComplete
});

/**
 * @param {SubmitFeedbackPayload} payload
 * @returns {{payload: SubmitFeedbackPayload, type: string}}
 */
export const chatFeedbackSuccess = (payload) => ({
  type: CHAT_FEEDBACK_SUCCESS,
  payload
});

/**
 * @param {{email: string, onComplete: function, onFailure: function}} payload
 * @returns {{payload: {email: string}, type: string, onComplete: function, onFailure: function}}
 */
export const sendTranscript = ({ email, onComplete, onFailure }) => ({
  type: SEND_CHAT_TRANSCRIPT,
  payload: {
    email
  },
  onComplete,
  onFailure
});

/**
 * @param {{payload: {}, onComplete: function, onFailure: function}} payload
 * @returns {{payload: {}, type: string, onComplete: function, onFailure: function}}
 */
export const sendUserToThirdPartyForReview = ({ payload, onComplete, onFailure }) => ({
  type: SEND_USER_TO_THIRD_PARTY_FOR_REVIEW,
  payload,
  onComplete,
  onFailure
});

/**
 * @param {string} status - //TODO import('../../constants').CHAT_STATE
 * @returns {{payload: *, type: string}}
 */
export const setChatStatus = (status) => ({
  type: SET_CHAT_STATUS,
  payload: status
});

/**
 * @returns {{payload: {campaign: string, popup: boolean}, type: string}}
 * @param {{campaign: string, popup: boolean}} data
 */
export const setChatOpenedFrom = (data) => ({
  type: SET_CHAT_OPENED_FROM,
  payload: data
});

/**
 * @param {boolean} isMinimized
 * @returns {{payload: boolean, type: string}}
 */
export const setChatMinimized = (isMinimized) => ({
  type: SET_CHAT_MINIMIZED,
  payload: isMinimized
});

export const setChatShaking = (isShaking) => ({
  type: SET_CHAT_SHAKING,
  payload: isShaking
});

/**
 * @param {boolean} isChatWindowClosable
 * @returns {{payload: boolean, type: string}}
 */

export const setIsChatWindowClosable = (isChatWindowClosable) => ({
  type: SET_CHAT_WINDOW_CLOSABLE,
  payload: isChatWindowClosable
});

/**
 * @param {{onComplete: function, onFailure: function}} payload
 * @returns {{onComplete: function, onFailure: function, type: string}}
 */
export const uploadFiles = ({ onComplete, onFailure }) => ({
  type: SUBMIT_FILES_FOR_UPLOAD,
  onComplete,
  onFailure
});

export const failedToLoadVisitorToken = () => ({
  type: FAILED_TO_LOAD_VISITOR_TOKEN
});

/**
 * @param {{message: string, fe_ts: number}} payload
 * @returns {{payload: {message: string, fe_ts: number}, type: string}}
 */
export const sendChatMessagePending = ({ message, fe_ts }) => ({
  type: SEND_CHAT_MESSAGE_PENDING,
  payload: {
    message,
    fe_ts
  }
});

/**
 * @param {{id: number, fe_ts : number}} payload
 * @returns {{payload: {id, fe_ts}, type: string}}
 */
export const sendChatMessageSucceeded = ({ id, fe_ts }) => ({
  type: SEND_CHAT_MESSAGE_SUCCEEDED,
  payload: {
    id,
    fe_ts
  }
});
/**
 * @param {{fe_ts : number}} payload
 * @returns {{payload: {fe_ts}, type: string}}
 */
export const sendChatMessageFailed = ({ fe_ts }) => ({
  type: SEND_CHAT_MESSAGE_FAILED,
  payload: {
    fe_ts
  }
});

/** @returns {{type: string}} */
export const closeChatUIWindow = () => ({ type: CLOSE_CHAT_UI_WINDOW });

/**
 * @param {{inquiry: string, onComplete: function, onFailure: function}} payload
 * @returns {{payload: {inquiry: string}, type: string, onComplete: function, onFailure: function}}
 */
export const sendInquiry = ({ inquiry, onComplete, onFailure }) => ({
  type: SEND_CHAT_INQUIRY,
  payload: {
    inquiry
  },
  onComplete,
  onFailure
});

export const tryingToEstablishWebsocketConnection = () => ({
  type: TRYING_TO_ESTABLISH_WEBSOCKET_CONNECTION,
  payload: {}
});

export const websocketConnectionEstablished = () => ({
  type: WEBSOCKET_CONNECTION_ESTABLISHED,
  payload: {}
});

export const subsequentSocketConnectRetries = ({ reconnectsLeft }) => ({
  type: SUBSEQUENT_SOCKET_CONNECT_RETRIES,
  payload: { reconnectsLeft }
});

export const exceededSocketConnectRetries = ({ count }) => ({
  type: SUBSEQUENT_SOCKET_CONNECT_RETRIES,
  payload: { count }
});

export const subsecquentFetchConnectionsRetries = ({ count }) => ({
  type: SUBSEQUENT_FETCH_CONNECTIONS_RETRIES,
  payload: { count }
});

export const userUnseenChatMessages = () => ({ type: USER_UNSEEN_CHAT_MESSAGES });
export const userResetUnseenChatMessages = () => ({ type: USER_RESET_UNSEEN_CHAT_MESSAGES });

/**
 * Creates an action to set the AI assistant thread ID in the Redux store.
 * @param {null | string} threadId - The new thread ID to be set.
 * @returns {{type: string | null, payload: string | null}} An action object with the type `SET_AI_ASSISTANT_THREAD_ID` and the new thread ID as the payload.
 */

export const setAiAssistantThreadId = (threadId) => ({
  type: SET_AI_ASSISTANT_THREAD_ID,
  payload: threadId
});
